<template>
  <nav class="mt-10 border-t border-b border-themeGray">
    <div class="navigation-menu flex w-full justify-between items-center">
      <div
        class="flex space-x-4 text-sm font-robotoMedium lg1024:space-x-8"
        id="navMenu"
        ref="navMenu"
      >
        <router-link
          v-for="item in menu"
          :key="item.name"
          :ref="item.name"
          :to="item.link"
          class="pt-4 pb-4 navigation-menu__link"
          :class="{ active: currentUrl == item.category }"
          >{{ item.name }}</router-link
        >
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavigationMenuTop",
  data() {
    return {
      position: 0,
      max: 2,
      menu: [],
    };
  },
  methods: {
    async getMenuTitles() {
      let getter = new Promise((resolve, reject) => {
        try {
          this.menu = this.$store.getters.getTranslation("menu");

          if (Array.isArray(this.menu)) {
            this.menu = this.menu.map((item, index) => {
              return {
                name: item,
                category:
                  index === 0
                    ? "newPosts"
                    : index === 1
                    ? "СМИ о нас"
                    : index === 2
                    ? "Coral Club"
                    : "События",
                link:
                  index === 0
                    ? "/"
                    : index === 1
                    ? "/smi"
                    : index === 2
                    ? "/coral-club"
                    : "/events",
              };
            });
          } else {
            const newMenu = [];
            Object.entries(this.menu).forEach(([index, item]) => {
              newMenu.push({
                name: item,
                category: index,
                link: `/${index}`,
              });
            });

            this.menu = newMenu;
          }

          resolve(this.menu);
        } catch (error) {
          // console.log(error);
          reject(error);
        }
      });
      await getter;
      return this.menu;
    },
  },
  computed: {
    currentUrl() {
      return this.$store.getters.getCurrentUrl;
    },
  },
  async mounted() {
    await this.getMenuTitles();
  },
};
</script>

<style scoped>
#navMenu {
  transition: margin 300ms ease;
}
.active,
.router-link-exact-active {
  border-bottom: 2px solid #413d58;
}
.navigation-menu {
  overflow: scroll;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}

.navigation-menu::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

.navigation-menu__link {
  white-space: nowrap;
}
</style>
